import { useQuery } from '@tanstack/react-query'

import { jobsApi, type StudentJobFilters } from '@/features/jobs/api/jobs.api'

export function useStudentJobs(filters: StudentJobFilters) {
  return useQuery({
    queryKey: ['student', 'jobs', filters],
    queryFn: () => jobsApi.list(filters),
    placeholderData: (previous) => previous,
  })
}

export function useStudentJob(jobId: number) {
  return useQuery({
    queryKey: ['student', 'jobs', jobId],
    queryFn: () => jobsApi.get(jobId),
  })
}
